<template>
    <div id="SamplesRequestWrapper">
        <h3>サンプル発送/関係者販売 リスト</h3>
        <div id="RequestListHeader">
            <div class="SampleRequestColumn SampleRequestProduct" title="商品">
                商品
            </div>
            <div class="SampleRequestColumn SampleRequestAmount" title="数">
                数
            </div>
            <div class="SampleRequestColumn SampleRequestOrderer" title="注文者名">
                注文者名
            </div>
            <div class="SampleRequestColumn SampleRequestReason" title="理由">
                理由
            </div>
            <div class="SampleRequestColumn SampleRequestInCharge" title="記入者及び備考">
                記入者及び備考
            </div>
            <div class="SampleRequestColumn SampleRequestInCharge" title="サンプルタイプ">
                サンプルタイプ
            </div>
            <div class="SampleRequestColumn ButtonColumn">

            </div>
        </div>
        <div id="SamplesRequestList">
            <SamplesRequest v-for="entry in SamplesRequests"
                :key="entry.id"
                :ID="entry.id"
                :Product="entry.productName"
                :StyleNumber="entry.styleNumber"
                :Amount="entry.amount"
                :Orderer="entry.orderer"
                :InCharge="entry.inCharge"
                :Reason="entry.reason"
                :SampleType="1"
                :SampleTypeOptions="SampleTypeOptions"
                :-on-update-request="UpdateRequestedSamples"
                :-on-delete-request="DeleteRequestedSamples"
            />
        </div>
        <div class="Separator"></div>
        <div style="margin-bottom: 25px;">
            <h3 style="margin-bottom: 10px;">新しい直販出荷保留リクエストを追加する</h3>
            <div>
                <div id="NewSampleRequestBoxTop" style="height: 18px;">
                    <div class="SampleRequestColumn SampleRequestProduct" title="品番">
                        {{ NewRequestedProduct }}
                    </div>
                    <div class="SampleRequestColumn SampleRequestAmount"></div>
                    <div class="SampleRequestColumn SampleRequestOrderer"></div>
                    <div class="SampleRequestColumn SampleRequestReason"></div>
                    <div class="SampleRequestColumn SampleRequestInCharge"></div>
                    <div class="ButtonColumn"></div>
                </div>
                <div id="NewSampleRequestBox">
                    <div class="NewRequestData SampleRequestProduct">
                        <GenericMultiDropdown style="height: 36px;" :options="NewRequestOptions" :-allow-multiple=false :-close-on-select=true :-on-change="OnNewRequestProductSelected" />
                    </div>
                    <div class="NewRequestData SampleRequestAmount">
                        <input id="NewRequestAmountInput" :value="NewRequestAmount" @change="CheckAmountInput" />
                    </div>
                    <div class="NewRequestData SampleRequestOrderer">
                        <input id="NewRequestOrdererInput" :value="NewRequestOrderer" @input="OnTypingOrderer" @change="OnNewRequestOrderer" />
                        <div v-if="ShowOrdererHint === true" style="position: relative;">
                            <div id="OrdererHintBox">
                                <OrdererHint v-for="entry in NewRequestMatchinOrdererOptions" :key="entry.id" :OrdererName="entry.name" :ID="entry.id" :OnClick="OnClickedOrdererHint" />
                            </div>
                        </div>
                    </div>
                    <div class="NewRequestData SampleRequestReason">
                        <div>
                            <textarea style="resize: none; width: 95%; height: 27px;" :value="NewRequestReason" placeholder="理由を入力してください。" @input="OnNewRequestReason"> </textarea>
                        </div>
                    </div>
                    <div class="NewRequestData SampleRequestInCharge">
                        <input type="text" :value="NewRequestInCharge" @change="OnNewRequestInCharge" />
                    </div>
                    <div class="NewRequestData SampleRequestSampleType">
                        <GenericDropdown :options="SampleTypeOptions" />
                    </div>
                    <div :class="{SendSamplesRequestBtn: true, NewRequestData:true, Button:true, ButtonGreen:true, Disabled:!IsNewRequestValid}" @click="RequestNewSample" >
                        登録する
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import GenericMultiDropdown from '@/components/GenericMultiDropdown.vue';
import OrdererHint from '@/components/OrdererHint.vue';
import SamplesRequest from '@/components/SamplesRequest.vue';
import GenericDropdown from '@/components/GenericDropdown.vue';

export default{
    components:{
        GenericDropdown,
        GenericMultiDropdown,
        OrdererHint,
        SamplesRequest,
    },
    async mounted(){
        this.NewRequestInCharge = this.$GetUsername();
        
        await this.GetOrderers();
        await this.GetProducts();
        await this.GetRequestedSamples();
    },
    computed:{
        IsNewRequestValid() {
            console.log(`Is request valid:: Prod: ${this.NewRequestedProduct !== ''} InCharge: ${this.NewRequestInCharge !== ''} Orderer: ${this.NewRequestOrderer !== ''} Reason: ${this.NewRequestReason !== ''}`,
            (this.NewRequestedProduct !== '' &&
            this.NewRequestInCharge !== '' &&
            this.NewRequestOrderer !== '' &&
            this.NewRequestReason !== ''));

            return this.NewRequestedProduct !== '' &&
            this.NewRequestInCharge !== '' &&
            this.NewRequestOrderer !== '' &&
            this.NewRequestReason !== '';
        }
    },
    methods:{
        async GetOrderers()
        {
            const param = {
                SessionToken: this.$GetToken(),
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}samples/orderer`, param)
            .then(async response =>{
                return response.data;
            })
            .catch (error =>{
                console.log('Error', error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });
            
            this.OrderersOptions = result;
            
            if (result.length === 0)
            {
                this.OrderersOptions.push({name:`登録された注文者名はありません。名前を入力してください。`, id: -1});
            }
        },
        async GetProducts()
        {
            const param = {
                SessionToken: this.$GetToken(),
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}zaiko/products`, param)
            .then(async response =>{
                return response.data;
            })
            .catch (error =>{
                console.log('Error', error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });
            
            if (result === null)
            {
                return;
            }

            this.Products = result;
            console.log(`products`, result);
            this.NewRequestOptions = [];

            for (let i = 0; i < this.Products.length; i++)
            {
                const p = this.Products[i];
                console.log('add option ', `${p.productName} - ${p.productCode}`);
                this.NewRequestOptions.push({label: `${p.productName} 「${p.productCode}」`, value: p.productCode});
            }
        },
        async GetRequestedSamples()
        {
            const param = {
                SessionToken: this.$GetToken(),
            };
            
            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}samples/requests`, param)
            .then(async response =>{
                return response.data;
            })
            .catch (error =>{
                console.log('Error', error);
                return null;
            });
            
            if (result === null)
            {
                return;
            }
            
            this.SamplesRequests = result;
            console.log(result);
        },
        async UpdateRequestedSamples(data)
        {
            const param = {
                SessionToken: this.$GetToken(),
                Data: data,
            };
            
            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}samples/update`, param)
            .then(async response =>{
                return response.data;
            })
            .catch (error =>{
                console.log('Error', error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });
            
            if (result === null)
            {
                return;
            }
            
            console.log(result);
        },
        async DeleteRequestedSamples(id)
        {
            const param = {
                SessionToken: this.$GetToken(),
                ID: id,
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}samples/delete`, param)
            .then(async response =>{
                return response.data;
            })
            .catch (error =>{
                console.log('Error', error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });
            
            if (result === null)
            {
                return;
            }
            
            console.log(result);
        },
        async RequestNewSample()
        {
            if (this.IsNewRequestValid === false)
            {
                if (this.NewRequestedProduct === '')
                {
                    alert('商品を選択してください。');
                    return;
                }

                if (this.NewRequestInCharge === '')
                {
                    alert('記入者を入力してください。');
                    return;
                }
            }

            const param = {
                SessionToken: this.$GetToken(),
                Data:{
                    Product: this.NewRequestedProduct,
                    Amount: this.NewRequestAmount,
                    OrdererID: this.NewRequestOrdererID,
                    OrdererName: this.NewRequestOrderer,
                    InCharge: this.NewRequestInCharge,
                    Reason: this.NewRequestReason,
                    SampleType: this.NewRequestSelectedSampleOption,
                },
            };

            console.log('Add new sample request', param);

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}samples/update`, param)
            .then(async response => {
                response.data.status = response.status;
                return response.data;
            })
            .catch (error => {
                console.log('Error', error);
                return null;
            });

            console.log(result);
            if (result !== null && result.status === 201)
            {
                alert(`リクエストは登録されました。`);
                this.NewRequestedProduct = '';
                this.NewRequestAmount = 1;
                this.NewRequestReason = '';
                this.NewRequestOrderer = '';
                this.NewRequestOrdererID = -1;
                this.NewRequestInCharge = this.$GetUsername();
                this.NewRequestSelectedSampleOption = 0;

                this.GetRequestedSamples();
            }
        },
        OnNewRequestProductSelected(products)
        {
            this.NewRequestedProduct = products ? products.value : '';
        },
        CheckAmountInput(event)
        {
            if (this.OnlyNumberRegex.test(event.target.value) === true)
            {
                const amount = parseInt(event.target.value);
                this.NewRequestAmount = Math.max(amount, this.NewRequestAmount);
                event.target.value = this.NewRequestAmount;
            }
            else
            {
                event.target.value = this.NewRequestAmount;
            }
        },
        OnNewRequestInCharge(event)
        {
            this.NewRequestInCharge = event.target.value;
        },
        OnTypingOrderer(event)
        {
            this.NewRequestOrdererID = -1;
            const inp = event.target.value;
            this.NewRequestOrderer = inp;
            this.ShowOrdererHint = true;

            const searchString = this.NewRequestOrderer.toLowerCase();
            this.NewRequestMatchinOrdererOptions = [];

            // Show only orderers matching current input
            for (let i = 0; i < this.OrderersOptions.length; i++)
            {
                if (this.OrderersOptions[i].name.toLowerCase().includes(searchString))
                {
                    this.NewRequestMatchinOrdererOptions.push(this.OrderersOptions[i]);
                }
            }
        },
        OnNewRequestOrderer()
        {
            // Have to delay this otherwise
            // the box closes before the click
            // goes through to the hint element
            setTimeout(()=>{
                this.ShowOrdererHint = false;
            }, 200);
        },
        OnClickedOrdererHint(id, name)
        {
            if (id > 0)
            {
                this.NewRequestOrderer = name;
                this.NewRequestOrdererID = id;
                this.ShowOrdererHint = false;
            }
        },
        OnNewRequestReason(event)
        {
            this.NewRequestReason = event.target.value;
        },
    },
    data(){
        return{
            Products: [],
            OrderersOptions: [],
            SamplesRequests: [],
            NewRequestOptions: [],
            NewRequestMatchinOrdererOptions: [],
            NewRequestedProduct: '',
            NewRequestAmount: 1,
            NewRequestOrderer: '',
            NewRequestOrdererID: -1,
            NewRequestReason: '',
            NewRequestInCharge: '',
            OnlyNumberRegex: new RegExp('^[0-9]+$'),
            ShowOrdererHint: false,
            SampleTypeOptions: [
                {label: 'サンプル提供', value: 0},
                {label: '関係者販売', value: 1}
            ],
            NewRequestSelectedSampleOption: '',
        }
    }
}
</script>

<style>
#SamplesRequestWrapper
{
    padding: 3px 10px 15px 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
}

#SamplesRequestList
{
    margin-bottom: 30px;
    flex: 1;
    overflow-y: auto;
}

#RequestListHeader
{
    display: flex;
    border-bottom: 1px solid #c6c6c6;
    margin-bottom: 20px;
}

#NewSampleRequestBox
{
    display: flex;
}

#NewSampleRequestBox .NewRequestData
{
    display: flex;
    flex-direction: column;
    justify-content: center;
    white-space: nowrap;
}

#NewSampleRequestBoxTop
{
    display: flex;
}

#NewSampleRequestBox .multiselect
{
    box-shadow: 1px 4px 3px 2px rgba(100, 100, 100, 0.5);
    border-radius: 10px;
    align-content: center;
}

#NewSampleRequestBox .multiselect__placeholder
{
    padding-left: 15px;
}

#NewSampleRequestBox .multiselect__single
{
    margin-bottom: 0px;
    padding-right: 5px;
}

.SampleRequestProduct
{
    width: 22%;
}

.SampleRequestAmount
{
    /* width: 70px; */
    width: 3%;
}

.SampleRequestAmount input
{
    /* width: 70px; */
    text-align: center;
    font-size: 1.1rem;
}

.SampleRequestOrderer
{
    /* flex: 0.4; */
    width: 7%;
}

.SampleRequestReason
{
    /* flex: 0.5; */
    width: 13%;
}

.SampleRequestInCharge
{
    /* flex: 0.4; */
    width: 8%;
}

.SampleRequestOrderNumber
{
    /* flex: 0.4; */
    width: 8%;
}

.SampleRequestZendeskTicket
{
    /* flex: 0.4; */
    width: 8%;
}

.SampleRequestColumn
{
    align-content: center;
    white-space: nowrap;
    align-items: center;
    text-align: center;
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.SampleRequestColumn span
{
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.SampleRequestColumn + .SampleRequestColumn 
{
    margin-left: 10px;
}

.NewRequestData + .NewRequestData
{
    margin-left: 10px;
}

.ButtonColumn
{
    /* flex: 0.2; */
    width: 5%;
    overflow: hidden;
}

#NewRequestInCharge span
{
    align-content: center;
}

.Disabled
{
    color: gray;
    cursor: default;
    background-color: rgba(200, 200, 200, 0.5) !important;
}

.SendSamplesRequestBtn
{
    border-radius: 5px;
    justify-content: center;
    height: 36px;
    place-self: end;
    padding: 0px 10px;
    margin: 0px 10px 0px 20px !important;
}

#OrdererHintBox
{
    border-right: 1px solid rgb(226, 226, 226);
    border-left: 1px solid rgb(226, 226, 226);
    border-bottom: 1px solid rgb(226, 226, 226);
    background-color: rgba(250, 250, 250, 0.0);
    position: absolute;
    top: 2px;
    left: 0px;
    font-size: 0.8rem;
    width: 100%;
}

</style>